import { render, staticRenderFns } from "./EcgRadioGroup.vue?vue&type=template&id=c48714a8&"
import script from "./EcgRadioGroup.vue?vue&type=script&lang=js&"
export * from "./EcgRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./EcgRadioGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports